import { render, staticRenderFns } from "./ExaminationFinding.vue?vue&type=template&id=094b5edd&scoped=true&"
import script from "./ExaminationFinding.vue?vue&type=script&lang=js&"
export * from "./ExaminationFinding.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationFinding.vue?vue&type=style&index=0&id=094b5edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b5edd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VLayout,
  VSpacer,
  VTab,
  VTabItem,
  VTabs,
})
